/*
* Styling   https://datatables.net/manual/styling/classes
* */
class datatablesModule {
    constructor() {
        this.options = {
            "element": $('#monitoring-table')
        };

        this.positioningLineInfoLayer(); // empty
        this.datatablesEventListener();
    }

    /*
    * @desc     Log events to console
    * @todo     delete at release
    * */
    eventListenerLog($this) {
        //console.group('CLICK EVENT TEST UNIT');
        //console.log('HTMLElement: ', $this.prop("tagName"));
        //console.log('Class: ', $this.attr('class'));
        //console.log('Parent-Class: ', $this.parent().attr('class'));
        //console.groupEnd();
    }

    positioningLineInfoLayer = () => {
        let lineCard = document.querySelector('.line-card');
        let table = document.querySelector('#monitoring-table');
    }

    datatablesEventListener = () => {
        let self = this;
        this.options.element.on('click', 'td.line', function () {
            let $card = $('.line-card'),
                data = {
                    line: $(this).parent().attr('data-line'),
                    fullname: $(this).parent().attr('data-fullname'),
                    subnet: $(this).parent().attr('data-subnet'),
                    runtime: $(this).parent().attr('data-runtime'),
                    evu: $(this).parent().attr('data-evu')
                };

            $card.removeClass('hidden');
            $card.find('.line').text(data.line);
            $card.find('.fullname').text(data.fullname);
            $card.find('.subnet').text(data.subnet);
            $card.find('.runtime').text(data.runtime);
            $card.find('.evu').text(data.evu);
        });

        // example
        // do some maths here
        // td.complexity => switch??
        this.options.element.on('mouseover', 'td.complexity', function () {
            let quarters = $(this)
                    .parent()
                    .attr('data-complexity-quarter') // todo dynamic??
                    .split(','),
                $target = $('.hoverbox').find('ul');

            $target.empty();
            $.each(quarters, function(index, item) {
                $target.append(`<li class="list-group-item">${item}</li>`)
            });
        });
    }
//
}
